import './customerGlobal.css';

export const CustomerGlobalStyles = () => null;
